module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/access_main-visual_bg-fd03b2c6bbcaae412b47d239e6382107.png";